// extracted by mini-css-extract-plugin
export default {"addressAction":"i7-z","loading":"j7-z"};